import { render, staticRenderFns } from "./TechResumeCreate.vue?vue&type=template&id=1b612aa8&"
import script from "./TechResumeCreate.vue?vue&type=script&lang=js&"
export * from "./TechResumeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports